import { combineReducers } from 'redux'
import { reducer as authReducer } from './modules/auth/index'
import { reducer as coreReducer } from './modules/core/index'
import { reducer as userReducer } from './modules/user/index'
import { reducer as countryReducer } from './modules/country/index'
import { reducer as patientReducer } from './modules/patient/index'
import { reducer as casesReducer } from './modules/case/index'
import { reducer as protocolReducer } from './modules/observationalProtocol/index'
import { reducer as unitReducer } from './modules/units'
import { reducer as chartReducer } from './modules/chart'
import { reducer as configurationReducer } from './modules/configuration'
import { reducer as jurisdictionReducer } from './modules/jurisdiction'
import { reducer as languageReducer } from './modules/language'
import { reducer as form } from 'redux-form'

export default combineReducers({
	auth: authReducer,
	form: form,
	core: coreReducer,
	user: userReducer,
	country: countryReducer,
	patient: patientReducer,
	cases: casesReducer,
	protocol: protocolReducer,
	units: unitReducer,
	chart: chartReducer,
	language: languageReducer,
	configuration: configurationReducer,
	jurisdiction: jurisdictionReducer
})
